var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import Price from '../../Price';
import { withSkeleton } from '../../Skeleton';
import { OwnSkeleton } from '../styles';
var StyledPrice = styled(Price)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0.5rem 0.5rem;\n  position: relative;\n"], ["\n  margin: 0 0.5rem 0.5rem;\n  position: relative;\n"])));
var ProductPrice = function (priceProps) {
    /* eslint-disable react/jsx-props-no-spreading */
    return priceProps && priceProps.currency && priceProps.price ? (React.createElement(StyledPrice, __assign({}, priceProps))) : null;
};
export default withSkeleton(ProductPrice, function () { return React.createElement(OwnSkeleton, { height: "2rem", width: "60%" }); });
var templateObject_1;
//# sourceMappingURL=index.js.map